/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { EngagementType } from "./EngagementType";
import {
  EngagementTypeFromJSON,
  EngagementTypeFromJSONTyped,
  EngagementTypeToJSON,
  EngagementTypeToJSONTyped,
} from "./EngagementType";

/**
 *
 * @export
 * @interface UpdateTeamMemberRequest
 */
export interface UpdateTeamMemberRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateTeamMemberRequest
   */
  teamMemberId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTeamMemberRequest
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTeamMemberRequest
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTeamMemberRequest
   */
  personalEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateTeamMemberRequest
   */
  personalPhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateTeamMemberRequest
   */
  mailingAddress?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpdateTeamMemberRequest
   */
  birthdayMonth?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpdateTeamMemberRequest
   */
  birthdayDay?: number | null;
  /**
   *
   * @type {LocalDate}
   * @memberof UpdateTeamMemberRequest
   */
  joinDate?: LocalDate | null;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateTeamMemberRequest
   */
  teamIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof UpdateTeamMemberRequest
   */
  legalFullName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateTeamMemberRequest
   */
  jobTitle?: string | null;
  /**
   *
   * @type {EngagementType}
   * @memberof UpdateTeamMemberRequest
   */
  engagementType?: EngagementType | null;
  /**
   *
   * @type {CurrencyCode}
   * @memberof UpdateTeamMemberRequest
   */
  currency?: CurrencyCode | null;
  /**
   *
   * @type {LocalDate}
   * @memberof UpdateTeamMemberRequest
   */
  endDate?: LocalDate | null;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateTeamMemberRequest
   */
  githubIds: Array<string>;
}

/**
 * Check if a given object implements the UpdateTeamMemberRequest interface.
 */
export function instanceOfUpdateTeamMemberRequest(
  value: object,
): value is UpdateTeamMemberRequest {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("firstName" in value) || value["firstName"] === undefined) return false;
  if (!("lastName" in value) || value["lastName"] === undefined) return false;
  if (!("teamIds" in value) || value["teamIds"] === undefined) return false;
  if (!("githubIds" in value) || value["githubIds"] === undefined) return false;
  return true;
}

export function UpdateTeamMemberRequestFromJSON(
  json: any,
): UpdateTeamMemberRequest {
  return UpdateTeamMemberRequestFromJSONTyped(json, false);
}

export function UpdateTeamMemberRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateTeamMemberRequest {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    firstName: json["firstName"],
    lastName: json["lastName"],
    personalEmail:
      json["personalEmail"] == null ? undefined : json["personalEmail"],
    personalPhone:
      json["personalPhone"] == null ? undefined : json["personalPhone"],
    mailingAddress:
      json["mailingAddress"] == null ? undefined : json["mailingAddress"],
    birthdayMonth:
      json["birthdayMonth"] == null ? undefined : json["birthdayMonth"],
    birthdayDay: json["birthdayDay"] == null ? undefined : json["birthdayDay"],
    joinDate: json["joinDate"] == null ? undefined : json["joinDate"],
    teamIds: json["teamIds"],
    legalFullName:
      json["legalFullName"] == null ? undefined : json["legalFullName"],
    jobTitle: json["jobTitle"] == null ? undefined : json["jobTitle"],
    engagementType:
      json["engagementType"] == null
        ? undefined
        : EngagementTypeFromJSON(json["engagementType"]),
    currency:
      json["currency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["currency"]),
    endDate: json["endDate"] == null ? undefined : json["endDate"],
    githubIds: json["githubIds"],
  };
}

export function UpdateTeamMemberRequestToJSON(
  json: any,
): UpdateTeamMemberRequest {
  return UpdateTeamMemberRequestToJSONTyped(json, false);
}

export function UpdateTeamMemberRequestToJSONTyped(
  value?: UpdateTeamMemberRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    firstName: value["firstName"],
    lastName: value["lastName"],
    personalEmail: value["personalEmail"],
    personalPhone: value["personalPhone"],
    mailingAddress: value["mailingAddress"],
    birthdayMonth: value["birthdayMonth"],
    birthdayDay: value["birthdayDay"],
    joinDate: value["joinDate"],
    teamIds: value["teamIds"],
    legalFullName: value["legalFullName"],
    jobTitle: value["jobTitle"],
    engagementType: EngagementTypeToJSON(value["engagementType"]),
    currency: CurrencyCodeToJSON(value["currency"]),
    endDate: value["endDate"],
    githubIds: value["githubIds"],
  };
}
